import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-[#F5F5F7] py-8 border-t border-[#E0E0E0]">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row justify-between">
          <div className="mb-6 md:mb-0">
            <h4 className="text-sm font-semibold text-[#951C25] mb-3">Pranaam365</h4>
            <p className="text-sm text-[#4A4A4A]/70 max-w-xs">© 2025 Pranaam365. All rights reserved.</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
            <div>
              <h4 className="text-sm font-semibold text-[#4A4A4A] mb-3">Services</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/book-tests" className="text-sm text-[#4A4A4A]/70 hover:text-[#951C25]">
                    Lab Tests
                  </Link>
                </li>
                <li>
                  <Link to="/book-tests" className="text-sm text-[#4A4A4A]/70 hover:text-[#951C25]">
                    Health Packages
                  </Link>
                </li>

              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-[#4A4A4A] mb-3">Company</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="#" className="text-sm text-[#4A4A4A]/70 hover:text-[#951C25]">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="#" className="text-sm text-[#4A4A4A]/70 hover:text-[#951C25]">
                    Contact
                  </Link>
                </li>
                <li>
                  <Link to="#" className="text-sm text-[#4A4A4A]/70 hover:text-[#951C25]">
                    Privacy
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
